import { useEffect, useRef, useState } from "react";
import Titel from "./Titel";
import InputField from "./InputField";
import validation from "../../Validations/Contact";
import useAxios from '../../hooks/useAxios';

const Contact = () => {
    const { AxiosPrivate } = useAxios()
    const [data, setData] = useState({})
    const [refresh, setRefresh] = useState()
    const isChanged = useRef(false)
    const errors = Object.keys(data).length ? validation(data) : {}
    const touch = { phone: true, mobile: true, sms: true, email: true, instagram: true, linkedin: true, counseling_telegram: true, technical_telegram: true, address: true, }

    useEffect(() => {
        const get = async () => {
            await AxiosPrivate.get('/contact')
                .then(res => {
                    setData(res.data.data)
                })
                .catch(err => alert(err.response?.data.message || 'مشکلی رخ داده است'))
        }
        get()
    }, [refresh])

    const handleChange = (e) => {
        const { name, value } = e.target
        isChanged.current = true
        setData(prev => {
            return {
                ...prev,
                [name]: value
            }
        })
    }

    const handleSumbit = async () => {
        if (Object.keys(errors).length) {
            return
        } else
            await AxiosPrivate.put('/contact/update', { ...data, _method: "PUT" })
                .then(res => {
                    alert(res.data.messgae || 'با موفقیت ویرایش شدند')
                    isChanged.current = false
                    setRefresh(Math.random())
                })
                .catch(err => alert(err.response?.data.message || 'مشکلی رخ داده است'))
    }
    return (
        <>
            <div className="p-4">
                <Titel title='تغییر مشخصات' className='lg:text-xl' />
                <form>
                    <div className="flex flex-wrap gap-x-1 justify-between py-4 my-4">
                        <InputField label={'تلفن'} id={4} max_width={'49%'} name={'phone'} type={'tel'}  {...{ data, handleChange, touch, errors }} />
                        <InputField label={'موبایل'} id={5} max_width={'49%'} name={'mobile'} type={'tel'}  {...{ data, handleChange, touch, errors }} />
                        <InputField label={'پیامک'} id={5} max_width={'49%'} name={'sms'} type={'tel'}  {...{ data, handleChange, touch, errors }} />
                        <InputField label={'ایمیل'} id={6} max_width={'49%'} name={'email'} type={'email'}  {...{ data, handleChange, touch, errors }} />
                        <InputField label={'اینستاگرام'} id={1} max_width={'49%'} name={'instagram'} type={'link'}  {...{ data, handleChange, touch, errors }} />
                        <InputField label={'لینکدین'} id={3} max_width={'49%'} name={'linkedin'} type={'link'}  {...{ data, handleChange, touch, errors }} />
                        <InputField label={'مشاوره تلگرام'} id={2} max_width={'49%'} name={'counseling_telegram'} type={'link'}  {...{ data, handleChange, touch, errors }} />
                        <InputField label={'فنی تلگرام'} id={2} max_width={'49%'} name={'technical_telegram'} type={'link'}  {...{ data, handleChange, touch, errors }} />
                        <div className="relative pb-6 mb-4 min-w-28 max-w-[100%] w-full">
                            <div className="w-full relative">
                                <textarea rows="5" name='address' value={data.address} onChange={handleChange}
                                    className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 appearance-none dark:text-white focus:outline-none focus:ring-0 peer"
                                    placeholder="آدرس"
                                />
                                <span className="absolute -top-6 left-3">{data.address?.length}</span>
                            </div>
                            {touch.address && errors.address && <p className="absolute right-2 bottom-0 text-xs text-red-600">{errors.address}</p>}
                        </div>
                        <div className="w-full flex sm:items-center items-start gap-4 sm:text-base text-sm sm:flex-row flex-col">
                            <p>ایجاد: {new Date(data.created_at).toLocaleString('fa-IR')}</p><span className="sm:block hidden">|</span>
                            <p>ویرایش: {new Date(data.updated_at).toLocaleString('fa-IR')}</p>
                        </div>
                    </div>
                    {isChanged.current && <button onClick={handleSumbit} type="button" className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br 
                     focus:outline-none shadow-lg shadow-blue-500/50 dark:shadow-lg dark:shadow-blue-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 ">ویرایش</button>}
                </form>
            </div>
        </>
    );
};

export default Contact;